"use strict";
var ExcludeMetadata = (function () {
    function ExcludeMetadata(target, propertyName, options) {
        this.target = target;
        this.propertyName = propertyName;
        this.options = options;
    }
    return ExcludeMetadata;
}());
exports.ExcludeMetadata = ExcludeMetadata;

//# sourceMappingURL=ExcludeMetadata.js.map



//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/metadata/ExcludeMetadata.js
// module id = 1451
// module chunks = 3